module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage",
    staticStyle: {
      "background-color": "#f8f8f4",
      "position": "fixed",
      "min-height": "100%",
      "min-width": "100%",
      "padding": "0 0 0 0"
    },
    model: {
      value: (_vm.getVersionInfo),
      callback: function($$v) {
        _vm.getVersionInfo = $$v
      },
      expression: "getVersionInfo"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#0c2544",
      "position": "absolute",
      "height": "100%",
      "width": "260px"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "simple-text",
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.version) ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "normal"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showChangelog = true
      }
    }
  }, [_vm._v("\n            Version " + _vm._s(_vm.version) + " (" + _vm._s(_vm.date) + ")\n            ")]), _vm._v(" "), (_vm.showChangelog) ? _c('Changelog', {
    on: {
      "close": function($event) {
        _vm.showChangelog = false
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('LocaleSwitcher')], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "-260px"
    }
  }, [_c('form', {
    staticStyle: {
      "max-width": "500px",
      "min-width": "100px",
      "margin": "0 auto"
    },
    attrs: {
      "name": "LogInForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.tryLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("Login")))]), _vm._v(" "), (_vm.loginResult != '') ? _c('div', {
    staticClass: "section"
  }, [_vm._v(_vm._s(_vm.loginResult))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginUserName),
      expression: "loginUserName"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": _vm.$t('placeholder.Username'),
      "required": "required"
    },
    domProps: {
      "value": (_vm.loginUserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginUserName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section form-input-validate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginPassword),
      expression: "loginPassword"
    }],
    staticClass: "txbox __l",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.Password'),
      "required": "required"
    },
    domProps: {
      "value": (_vm.loginPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "section btn __l __block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("Login")))]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("login.New user?")) + "\n            "), _c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("login.Register here")) + "\n            ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://ocds.co",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/optima-inverted-logo.png",
      "width": "160px",
      "vertical-align": "middle",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2383c62e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/LoginPage.vue
// module id = 366
// module chunks = 1